export function calcularHorasReales(entrada, salida, abono) {
  let entradaHoras = entrada.split(':')[0]
  let entradaMinutos = entrada.split(':')[1]
  entrada = new Date(2021, 1, 1, entradaHoras, entradaMinutos)

  let salidaHoras = salida.split(':')[0]
  let salidaMinutos = salida.split(':')[1]
  salida = new Date(2021, 1, 1, salidaHoras, salidaMinutos)

  entrada = entrada.getTime()
  salida = salida.getTime()

  let horasReales = (salida - entrada) / (3600 * 1000)
  horasReales = abono ? -1 * horasReales : horasReales
  return horasReales
}